/**
 * languageChangedCapture — PostHog instrumentation for UI language changes (Issue #499)
 *
 * Emits ui_language_changed event when user changes the UI language. Properties
 * include both the new locale and the previous locale, for RTL analytics.
 *
 * First PostHog read: DISTINCT locale + counts; one distinct value = dead instrument (#1874/#1887).
 *
 * FAIL-OPEN (mega80 review-fix): this runs inside i18n's `languageChanged`
 * listener, between `document.documentElement.lang = lng` and the assignment
 * that advances `previousLocale`. A throw here would abort the listener and
 * leave `previousLocale` stale — i.e. telemetry breaking the very UI action it
 * exists to observe. PostHog is a commonly ad-blocked origin, and #499's target
 * population (ar/iw/ur) is the one most likely to be on a blocking browser, so
 * the unguarded path was reachable for exactly the users this instruments.
 * Same fail-open contract the mic probe carries (#1349/#1397).
 */

export function captureLanguageChanged(posthog, currentLocale, previousLocale) {
  if (!posthog || typeof posthog.capture !== 'function') return;

  try {
    posthog.capture('ui_language_changed', {
      locale: currentLocale,
      previous_locale: previousLocale,
    });
  } catch {
    // Never let a telemetry failure break language switching.
  }
}
